module.exports = __webpack_public_path__ + "media/images/swifticons/weather-thunderstorm-comment-47fa8952c2bbb617e230073dcfb4d442.svg";